module.exports = __webpack_public_path__ + "static/media/featured-img1.56e97618.jpg";